
import { Heart, Laptop, ShoppingBag, PaintBucket } from 'lucide-react';
import React from 'react';

interface TopCategory {
  id: string;
  name: string;
  icon: React.ReactNode;
}

export const topCategoriesData: TopCategory[] = [
  {
    id: 'made-in-rwanda',
    name: 'Made in Rwanda',
    icon: <Heart className="text-red-500" size={18} />
  },
  {
    id: 'electronics',
    name: 'Electronics',
    icon: <Laptop className="text-blue-500" size={18} />
  },
  {
    id: 'fashion',
    name: 'Fashion',
    icon: <ShoppingBag className="text-purple-500" size={18} />
  },
  {
    id: 'local-crafts',
    name: 'Local Crafts',
    icon: <PaintBucket className="text-orange-500" size={18} />
  }
];
